module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/145.90a8e419.png";